<template>
  <div class="smy__card-full-box">
    <Card
      class="smy__card-full"
      :bordered="false"
    >
      <p slot="title">
        首页
      </p>
      <p slot="extra" class="extra">
        <span class="ivu-tag-dot-inner ivu-tag-green"></span>
        欢迎使用单小二
      </p>
      <div class="personIndex">
        <!-- <p class="navigate">功能导航</p>
        <p>通过功能导航您可以快速打开您想要进入的功能模块</p>
        <AsyncCascader
          url="/area/list"
          placeholder="请选择地址"
          :value="addrVal"
          :level="2"
          @on-change="addrChange"
        />
        <DateRangePicker :value="dateList"/>
        <Button @click="changeDate">改变日期</Button> -->
      </div>
    </Card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AsyncCascader from '@/components/AsyncCascader'
import DateRangePicker from '@/components/DateRangePicker'

export default {
  name: 'personIndex',
  components: {
    AsyncCascader,
    DateRangePicker
  },
  data () {
    return {
      // addrVal: [],
      // dateList: ['2017/02/01', '2017/02/06']
    }
  },
  computed: {
    ...mapState('menu', [
      'thirdMenuList'
    ]),
    ...mapState('user', [
      'user'
    ]),
    personrole () {
      return this.user.sysrole
    }
  },
  methods: {
    ...mapActions('menu', [
      '_AddTag'
    ]),
    newTab (menu) {
      for (var val in this.thirdMenuList) {
        this.thirdMenuList[val].forEach((item, index) => {
          if (item.routerName === menu.name) {
            this._AddTag(item.parent_id + '-' + item.id)
          }
        })
      }
    }
    // addrChange (val) {
    //   console.log(val)
    // },
    // changeDate () {
    //   this.dateList = ['2017/02/07', '2017/02/09']
    // }
  },
  created () {
    // 高德地图测试
    // this.$http.get('http://restapi.amap.com/v3/config/district', {
    //   params: {
    //     key: '5593029938b6ca4acf18ef4eaeeb7af3',
    //     keywords: '中山市',
    //     subdistrict: '2'
    //   }
    // }).then(res => {
    //   let str = ''
    //   for (let area of res.districts[0].districts) {
    //     let center = area.center.split(',')
    //     str += `('${area.citycode}','${area.adcode}','${area.name}',${center[0]},${center[1]},'${area.level}', 28440),`
    //   }
    //   console.log(str)
    // })
  }
}
</script>

<style lang="less" scoped>
.personIndex{
  padding: 20px;
  p{
    line-height: 24px;
    color: #80848F;
    font-size: 12px;
  }
  .navigate{
    font-size: 14px;
    color: #405060;
  }
}
.personIndexUl{
  overflow: hidden;
  margin-top: 30px;
  ul li{
    float: left;
    width: 140px;
    text-align: center;
    font-size: 12px;
    line-height: 24px;
    .iconSet{
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background: #8CDFB5;
      margin: 0 auto;
      cursor: pointer;
      i{
        font-size: 30px;
        color: #fff;
        line-height: 60px;
      }
    }
    .iconSet:hover{
      background: #5ED298;
    }
    .top{
      color: #80848F;
      margin-top: 16px;
    }
    .bottom{
      color: #BBBEC4;
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/pages/PersonIndex.vue